import { TeamConfig } from "@/global/hooks/useTeamConfig";
import { GameFilters } from "@/global/store/data/types";
import { useTheme } from "@emotion/react";
import { Chip, ChipProps } from "@mui/material";
import React from "react";

interface Props {
  name: string;
  isSelected: boolean;
  label: string | React.ReactNode;
  onClick: (e: any) => void;
  size?: ChipProps["size"];
  isHidden?: boolean;
  isDisabled?: boolean;
}

export const FilterButton = ({
  name,
  isSelected,
  label,
  onClick,
  size,
  isHidden,
  isDisabled,
}: Props) => {
  const theme = useTheme();

  return (
    <Chip
      disabled={isDisabled || isHidden}
      size={size ? size : "medium"}
      clickable
      variant={isSelected ? "filled" : "outlined"}
      color={isSelected ? "primary" : "default"}
      label={label}
      onClick={() => onClick(name)}
      sx={{
        transition: "all 0.3s ease",
        display: isHidden ? "none" : "inherit",
      }}
    />
  );
};

export function renderButtonLabel(
  filterName: string,
  states: GameFilters,
  teamConfig: TeamConfig
) {
  const { seatCount, priceRange, dynamicSeatCount } = states;
  let label = "";

  if (filterName == "seat_counter") {
    label = `${seatCount} ${seatCount > 1 ? "Seats" : "Seat"}`;
  }

  if (filterName == "dynamic_seat_count") {
    // Calculate total from categorized seat counts
    const totalSeats = dynamicSeatCount.reduce((total, seatCount) => {
      return total + seatCount.seatCount;
    }, 0);
    label = `${totalSeats} ${totalSeats !== 1 ? "Seats" : "Seat"}`;
  }

  if (filterName == "price_selector") {
    const decimals =
      teamConfig?.uiConfigs?.gameFiltersSettings?.showPriceDecimals;
    const [min, max] = (priceRange?.selected || []).map((v) =>
      decimals ? Number(v).toFixed(2) : v
    );
    label = `$${min}-${max}`;
  }

  if (filterName == "date_range_selector") {
    label = "Date";
  }

  if (filterName == "opponent_selector") {
    label = teamConfig?.languages?.opponentSelectorTitle || "Opponent";
  }

  if (filterName == "accessibility_selector") {
    label = "Accessibility";
  }

  if (filterName == "section_selector") {
    label = "Any Section";
  }

  if (filterName == "category_selector") {
    label = teamConfig?.languages?.gameFilters?.category?.title || "Category";
  }

  return label;
}
